// @flow
import {FAMILY_FRIENDLY_FILTER_NAME} from '../constants';

type SearchParams = {
    +params: {filter?: ?(string[]), childrenCount?: number}
};

/**
 * based on whether current application state has family context
 */
export default function checkFamilyContext({
    params: {filter, childrenCount}
}: SearchParams) {
    return (
        (filter || []).includes(FAMILY_FRIENDLY_FILTER_NAME) ||
        +childrenCount > 0
    );
}
